import { Card, Divider } from "antd";
import React from "react";
import { ChecklistItemReadOnly } from "~/components/days/DayChecklistModal.jsx";
import { HelpBubble } from "~/components/help/helpBubble.jsx";
import { $t } from "~/i18n.js";
import { _parseDateTime } from "~/lib/localize.js";

const ChecklistSection = ({ title, items }) => {
  if (!items || items.length === 0) return null;
  const user_name = items ? items[0].user_name : null;
  const timestamp = items ? items[0].timestamp : null;

  return (
    <>
      <p className="bold" style={{ marginBottom: 4 }}>
        {title}

        {user_name && (
          <HelpBubble
            style={{ marginLeft: 8 }}
            title={$t("Beantwoord door")}
            content={
              <span>
                {user_name}, {_parseDateTime(timestamp)}
              </span>
            }
          />
        )}
      </p>
      <div style={{ marginBottom: 12 }}>
        {items.map((item, idx) => (
          <ChecklistItemReadOnly key={idx} item={item} />
        ))}
      </div>
    </>
  );
};

export const CardChecklist = ({ activeDay }) => {
  const startItems = activeDay?.checklist_start || [];
  const endItems = activeDay?.checklist_end || [];

  if (startItems.length === 0 && endItems.length === 0) return null;

  return (
    <div>
      <ChecklistSection title={$t("Start van de dag")} items={startItems} />
      
      <ChecklistSection title={$t("Einde van de dag")} items={endItems} />
    </div>
  );
};
